<div mat-dialog-content>
  <div class="alert-content alert-content-content text-center">
    <mat-icon>report_problem</mat-icon>
    <h3 class="my-2 lead">Are you sure ?</h3>
    <p class="message">{{content}} will be deleted</p>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-between gap-2">
  <button mat-button mat-dialog-close (click)="dialogRef.close()">Cancel</button>
  <button mat-button color="warn" mat-dialog-close cdkFocusInitial (click)="removeActiveTab()">{{isAlertMessage ? 'Exit' :
    'Confirm'}}</button>
</div>